import { screenSize } from '../constants';

export const resizeGame = (maxHeight: number, maxWidth: number, target: HTMLElement | null, isNeedSetScale: boolean = false, returnScaleValue: boolean = false): number | void => {
  let scale;
  let wWidth;
  let wHeight;

  wWidth = window.innerWidth;
  wHeight = window.innerHeight;
  const widthToHeight = maxWidth / maxHeight;
  const wWidthToHeight = wWidth / wHeight;

  if (wWidthToHeight > widthToHeight) {
    wWidth = wHeight * widthToHeight;
    scale = wWidth / maxWidth;
  } else {
    wHeight = wWidth / widthToHeight;
    scale = wHeight / maxHeight;
  }

  if (returnScaleValue) {
    return scale;
  }

  if (target != null) {
    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 || isNeedSetScale) {
      target.style.transform = `scale(${scale})`;
    } else {
      // @ts-ignore
      target.style.zoom = scale;
    }
  }
};

export const addEventListenerToResizeGame = () => {
  const target = document.querySelector('.root') as HTMLElement;
  window.addEventListener('resize', (_) => {
    resizeGame(screenSize.height, screenSize.width, target);
  });
}
